module.exports = __webpack_public_path__ + "img/bot5.865120d4.svg";